import templateUrl from './publishingAtAGlanceAccordion.html';
import './publishingAtAGlanceAccordion.scss';

import {createLogger} from '../../../common/logging.config';
const logger = createLogger('publishing-at-a-glance-accordion');

class PublishingAtAGlanceAccordionController {
	constructor($rootScope, $scope, $state, $document, homepageUtil) {
		this.$rootScope = $rootScope;
		this.$state = $state;
		this.$document = $document;
		this.maxDaysToShow = 5;
		this.maxEventsToShow = 8;
		this.homepageUtil = homepageUtil;
		
		this.getUserPreferences();

		this.$onChanges = (binding) => {
			// wait for binding entries promise to get delivered to create collapsed/expanded tracking array
			if (angular.isDefined(binding) && binding.entries && binding.entries.currentValue) {
				this.collapsed = new Array(this.entries.length).fill(true); //NOSONAR
				this.collapsed[0] = false;
				logger.info('entries binding updated');
			}
		}
		
		this.$onInit = () => {
			this.datesort = this.datesort || '+date';
			this.timesort = this.timesort || '+time';
		}
		
        
		// listen for the event to apply new preferences
		const handler = $rootScope.$on('apply-preferences', (event, payload) => {
			this.getUserPreferences();
		});
		$scope.$on('$destroy', handler);
	}

    // toggle the accordion at the specified index
    toggle(event, index) {
		// this routine is called for both keypress and mouse events
		const keycode = this.homepageUtil.getKeyCode(event);
		if (typeof keycode !== 'undefined') {
			// a key was pressed, accept enter or space to toggle current accordion
			if (keycode === 13 || keycode === 32) {
				event.preventDefault();
			}
			// down or up arrow, home or end, move title focus
			else if (keycode === 40 || keycode === 38 || keycode === 36 || keycode === 35) {
				let nextIndex;

				switch (keycode) {
					// down arrow key
					case 40:
						nextIndex = (index === this.entries.length - 1) ? 0 : index + 1;
						break;
					// home key
					case 36:
						nextIndex = 0;
						break;
					// end key
					case 35:
						nextIndex = this.entries.length - 1;
						break;
					// up arrow key
					case 38:
						nextIndex = (index === 0) ? this.entries.length - 1 : index - 1;
						break;
				}

				const activeId = angular.element(window.document.activeElement).attr('id');
				if (activeId && activeId.includes('-paneltitle-')) {
					let nextActiveId = activeId.substring(0, activeId.lastIndexOf('-') + 1).concat(nextIndex);
					const elem = this.$document.find('#' + nextActiveId);
					if (elem) {
						logger.info("focus accordion " + nextIndex);
						elem.focus();
						event.preventDefault();
					}
				}
				return;
			}
			// key is not accepted
			else {
				return;
			}
		}
		
    	if (this.entries && index < this.entries.length) {
    		logger.info("toggle panel " + index);
    		this.collapsed[index] = !this.collapsed[index];
    	}
    }
    
    getUserPreferences() {
		this.homepageUtil.getPublishingAtAGlancePreferences().then(rv => {
			// make sure we read something from storage
			if (Object.keys(rv).length > 0) {
				this.maxDaysToShow = rv.maxDaysToShow;
				this.maxEventsToShow = rv.maxEventsToShow;
			}
		});
    }
	
	isUndefined(value) {
		return angular.isUndefined(value);
	}

	isDefined(value) {
		return angular.isDefined(value);
	}

	navigateToDetails(event, kind, id, name) {
		// on keypress event, only accept enter or space
		const keycode = this.homepageUtil.getKeyCode(event);
		if (typeof keycode !== 'undefined' && keycode !== 13 && keycode !== 32) {
			return;
		}
		let detailState;
		let stateParams;
		if (kind && kind.length > 0) {
			switch (kind[0]) {
			case 'publishing-job':
				detailState = 'publishing-jobs';
				stateParams = {publishingJobId: id, publishingJobName: name};
				break;
			case 'managed':
				detailState = 'projects';
				stateParams = {projectId: id, projectName: name};
				break;
			}
		}
		if (detailState) {
			let myTab = '';
			switch (this.idprefix) {
				case 'c':
					myTab = 'published';
					break;
				case 'e':
					myTab = 'errors';
					break;
				case 'o':
					myTab = 'onHold';
					break;
				case 'p':
					myTab = 'pending';
					break;
				default:
					break;
			}
			stateParams.paagTab = myTab;
			this.$state.go('authoring.' + detailState + '.detail', stateParams);
		}
	}
}

export default {
//module.exports = {
	controller: ['$rootScope', '$scope', '$state', '$document', 'homepageUtil', PublishingAtAGlanceAccordionController ],
	bindings: {
		datesort: '@',
		timesort: '@',
		idprefix: '@',
		entries: '<'
	},
	templateUrl
};



// WEBPACK FOOTER //
// ./app/components/publishingAtAGlance/publishingAtAGlanceAccordion/publishingAtAGlanceAccordion.component.js